module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_7042.3cc619a4.png";